export const RADAR_PLAYBACK_RANGE_PRESETS = {
  LAST_1_HOUR: "LAST_1_HOUR",
  LAST_3_HOURS: "LAST_3_HOURS",
  LAST_6_HOURS: "LAST_6_HOURS",
  TODAY: "TODAY",
};

export const DEFAULT_RADAR_PLAYBACK_RANGE_PRESET = RADAR_PLAYBACK_RANGE_PRESETS.LAST_3_HOURS;

export const RADAR_PLAYBACK_RANGE_OPTIONS = [
  { value: RADAR_PLAYBACK_RANGE_PRESETS.LAST_1_HOUR, label: "Last 1 hour" },
  { value: RADAR_PLAYBACK_RANGE_PRESETS.LAST_3_HOURS, label: "Last 3 hours" },
  { value: RADAR_PLAYBACK_RANGE_PRESETS.LAST_6_HOURS, label: "Last 6 hours" },
  { value: RADAR_PLAYBACK_RANGE_PRESETS.TODAY, label: "Today" },
];

const BOGOTA_TIMEZONE = "America/Bogota";

function startOfTodayBogota(now = new Date()) {
  const dateStr = now.toLocaleDateString("en-CA", { timeZone: BOGOTA_TIMEZONE });
  return new Date(`${dateStr}T05:00:00.000Z`);
}

export function resolveRadarPlaybackRange(
  preset = DEFAULT_RADAR_PLAYBACK_RANGE_PRESET,
  now = new Date()
) {
  const end = now;

  switch (preset) {
    case RADAR_PLAYBACK_RANGE_PRESETS.LAST_1_HOUR:
      return {
        start: new Date(end.getTime() - 60 * 60 * 1000),
        end,
        preset,
      };
    case RADAR_PLAYBACK_RANGE_PRESETS.LAST_6_HOURS:
      return {
        start: new Date(end.getTime() - 6 * 60 * 60 * 1000),
        end,
        preset,
      };
    case RADAR_PLAYBACK_RANGE_PRESETS.TODAY:
      return {
        start: startOfTodayBogota(end),
        end,
        preset,
      };
    case RADAR_PLAYBACK_RANGE_PRESETS.LAST_3_HOURS:
    default:
      return {
        start: new Date(end.getTime() - 3 * 60 * 60 * 1000),
        end,
        preset: RADAR_PLAYBACK_RANGE_PRESETS.LAST_3_HOURS,
      };
  }
}

export function formatPlaybackFrameTimestamp(timestampIso, timeZone = BOGOTA_TIMEZONE) {
  if (!timestampIso) {
    return "—";
  }

  const date = new Date(timestampIso);
  if (Number.isNaN(date.getTime())) {
    return "—";
  }

  return date.toLocaleString(undefined, {
    timeZone,
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}
